import { Component, computed, DestroyRef, effect, inject, input, linkedSignal, signal } from '@angular/core';
import { DatePipe } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { rxResourceFixed } from '@zayan-erp/shared';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbModalService } from '@zayan-erp/shared';
import { DealOptionsService } from '../../../services/deal-options.service';
import { AddAddendumModalComponent } from '../../deal-detail/options/add-addendum-modal/add-addendum-modal.component';
import { DealAddendumPreviewComponent } from '../../options-tab/deal-addendums/deal-addendum-preview/deal-addendum-preview.component';
import { DealAddendumOptionsComponent } from '../../options-tab/deal-addendums/deal-addendum-options/deal-addendum-options.component';
import { DealAddendumDetailsComponent } from '../../options-tab/deal-addendums/deal-addendum-details/deal-addendum-details.component';
import { DealAddendumOptionDetailsComponent } from '../../options-tab/deal-addendums/deal-addendum-options/deal-addendum-option-details/deal-addendum-option-details.component';
import { DealOption } from '../../../models/deal-options-view.models';
type DealOptionWithExpandableView = DealOption & {
  isExpanded: boolean;
};
@Component({
  selector: 'specs-lot-addendum-view',
  imports: [
    DealAddendumPreviewComponent,
    DealAddendumOptionsComponent,
    DealAddendumDetailsComponent,
    DealAddendumOptionDetailsComponent,
    DatePipe
  ],
  templateUrl: './specs-lot-addendum-view.component.html',
  styleUrl: './specs-lot-addendum-view.component.scss'
})
export class SpecsLotAddendumViewComponent {
  private readonly dealOptionsService = inject(DealOptionsService);
  readonly modalConfig = inject(NgbModalService);
  readonly modal = inject(NgbModal);
  readonly destroyRef = inject(DestroyRef);

  readonly lotId = input.required<string>();
  readonly modelId = input.required<string>();
  readonly elevationId = input.required<string>();

  selectedAddendumId = signal<string | null>(null);
  selectedProductId = signal<string | null>(null);
  // selectedKitProductId = signal<string | null>(null);

  dealOptionsHistory: DealOptionWithExpandableView[] = [];

  dealsOptionsRxResource = rxResourceFixed({
    params: () => ({ lotId: this.lotId() }),
    defaultValue: [],
    stream: ({ params }) => {
      return this.dealOptionsService.getLotAddendums(params.lotId);
    }
  });

  isDealOptionsLoading = computed(() => this.dealsOptionsRxResource.status() === 'loading');
  dealsOptions = linkedSignal<DealOptionWithExpandableView[]>(() => {
    const options = this.dealsOptionsRxResource.value() ?? [];
    return options.map(
      option =>
        ({
          ...option,
          isExpanded: this.dealOptionsHistory.find(history => history.id === option.id)?.isExpanded ?? false
        }) as DealOptionWithExpandableView
    );
  });

  onDealsOptionsSet = effect(() => {
    this.dealOptionsHistory = this.dealsOptions();
  });

  selectedAddendum = computed(
    () => this.dealsOptions().find(addendum => addendum.id === this.selectedAddendumId()) ?? null
  );

  showAddendumDetails = computed(() => this.selectedAddendum() !== null && this.selectedProductId() === null);

  showOptionDetails = computed(() => this.selectedAddendum() !== null && this.selectedProductId() !== null);

  onOptionChanges(): void {
    this.dealsOptionsRxResource.reload();
  }

  openAddOptionModal(): void {
    const modalRef = this.modal.open(AddAddendumModalComponent, this.modalConfig.centerModal);
    const lotId = this.lotId();

    if (lotId) modalRef.componentInstance.setLotId(lotId);

    // const subscription = modalRef.componentInstance.saved.subscribe((savedData: AddendumCreatedEvent) => {
    const subscription = modalRef.componentInstance.saved.subscribe((savedData: any) => {
      // this.newlyCreatedBuilderReferenceId.set(savedData.builderReferenceId);
      this.dealsOptionsRxResource.reload();
      subscription.unsubscribe();
    });

    modalRef.closed.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      subscription.unsubscribe();
    });
  }

  // make sure this is a string
  onAddendumSelect(optionId: string): void {
    this.selectedAddendumId.set(optionId);
    this.selectedProductId.set(null);
  }

  selectedKitProductId: string | null = null;
  onAddendumProductSelect(addendumId: string, productId: string, isKitLinkedProduct: boolean = false): void {
    this.selectedAddendumId.set(addendumId);
    this.selectedProductId.set(productId);
    if (isKitLinkedProduct) {
      this.selectedKitProductId = productId;
    } else {
      this.selectedKitProductId = null;
    }
  }
}
